// Verse library grouped by theme. Used by the Verse Library page,
// "Send to Companion", and "Set as my Today verse".
export const VERSE_THEMES = [
  { key: "fear", label: "Fear & anxiety" },
  { key: "shame", label: "Shame & guilt" },
  { key: "strength", label: "Strength" },
  { key: "temptation", label: "Temptation" },
  { key: "peace", label: "Peace" },
  { key: "hope", label: "Hope" },
  { key: "perseverance", label: "Perseverance" },
  { key: "gratitude", label: "Gratitude" },
];

export const VERSE_LIBRARY = {
  fear: [
    { text: "So do not fear, for I am with you; do not be dismayed, for I am your God. I will strengthen you and help you.", ref: "Isaiah 41:10" },
    { text: "I sought the LORD, and he answered me; he delivered me from all my fears.", ref: "Psalm 34:4" },
    { text: "For God has not given us a spirit of fear, but of power and of love and of a sound mind.", ref: "2 Timothy 1:7" },
    { text: "Do not be anxious about anything, but in every situation, by prayer and petition, present your requests to God.", ref: "Philippians 4:6" },
    { text: "Be strong and courageous. Do not be afraid; the LORD your God will be with you wherever you go.", ref: "Joshua 1:9" },
  ],
  shame: [
    { text: "Therefore, there is now no condemnation for those who are in Christ Jesus.", ref: "Romans 8:1" },
    { text: "As far as the east is from the west, so far has he removed our transgressions from us.", ref: "Psalm 103:12" },
    { text: "Though your sins are like scarlet, they shall be as white as snow.", ref: "Isaiah 1:18" },
    { text: "If we confess our sins, he is faithful and just and will forgive us and purify us from all unrighteousness.", ref: "1 John 1:9" },
    { text: "Those who look to him are radiant; their faces are never covered with shame.", ref: "Psalm 34:5" },
  ],
  strength: [
    { text: "I can do all this through him who gives me strength.", ref: "Philippians 4:13" },
    { text: "But those who hope in the LORD will renew their strength. They will soar on wings like eagles.", ref: "Isaiah 40:31" },
    { text: "The LORD is my strength and my shield; my heart trusts in him, and he helps me.", ref: "Psalm 28:7" },
    { text: "My grace is sufficient for you, for my power is made perfect in weakness.", ref: "2 Corinthians 12:9" },
    { text: "The joy of the LORD is your strength.", ref: "Nehemiah 8:10" },
  ],
  temptation: [
    { text: "No temptation has overtaken you except what is common to mankind. And God is faithful; he will also provide a way out.", ref: "1 Corinthians 10:13" },
    { text: "Submit yourselves, then, to God. Resist the devil, and he will flee from you.", ref: "James 4:7" },
    { text: "Watch and pray so that you will not fall into temptation. The spirit is willing, but the flesh is weak.", ref: "Matthew 26:41" },
    { text: "Let us then approach God's throne of grace with confidence, so that we may find grace to help us in our time of need.", ref: "Hebrews 4:16" },
    { text: "I have hidden your word in my heart that I might not sin against you.", ref: "Psalm 119:11" },
  ],
  peace: [
    { text: "Peace I leave with you; my peace I give you. Do not let your hearts be troubled and do not be afraid.", ref: "John 14:27" },
    { text: "And the peace of God, which transcends all understanding, will guard your hearts and your minds in Christ Jesus.", ref: "Philippians 4:7" },
    { text: "You will keep in perfect peace those whose minds are steadfast, because they trust in you.", ref: "Isaiah 26:3" },
    { text: "Come to me, all you who are weary and burdened, and I will give you rest.", ref: "Matthew 11:28" },
    { text: "In peace I will lie down and sleep, for you alone, LORD, make me dwell in safety.", ref: "Psalm 4:8" },
  ],
  hope: [
    { text: "'For I know the plans I have for you,' declares the LORD, 'plans to give you hope and a future.'", ref: "Jeremiah 29:11" },
    { text: "May the God of hope fill you with all joy and peace as you trust in him.", ref: "Romans 15:13" },
    { text: "Because of the LORD's great love we are not consumed, for his compassions never fail. They are new every morning.", ref: "Lamentations 3:22-23" },
    { text: "Why, my soul, are you downcast? Put your hope in God, for I will yet praise him.", ref: "Psalm 42:11" },
    { text: "And hope does not put us to shame, because God's love has been poured out into our hearts through the Holy Spirit.", ref: "Romans 5:5" },
  ],
  perseverance: [
    { text: "Let us not become weary in doing good, for at the proper time we will reap a harvest if we do not give up.", ref: "Galatians 6:9" },
    { text: "Blessed is the one who perseveres under trial, because they will receive the crown of life.", ref: "James 1:12" },
    { text: "Let us run with perseverance the race marked out for us, fixing our eyes on Jesus.", ref: "Hebrews 12:1" },
    { text: "For though the righteous fall seven times, they rise again.", ref: "Proverbs 24:16" },
    { text: "Being confident of this, that he who began a good work in you will carry it on to completion.", ref: "Philippians 1:6" },
  ],
  gratitude: [
    { text: "Give thanks in all circumstances; for this is God's will for you in Christ Jesus.", ref: "1 Thessalonians 5:18" },
    { text: "Give thanks to the LORD, for he is good; his love endures forever.", ref: "Psalm 107:1" },
    { text: "Let the peace of Christ rule in your hearts. And be thankful.", ref: "Colossians 3:15" },
    { text: "This is the day the LORD has made; let us rejoice and be glad in it.", ref: "Psalm 118:24" },
    { text: "Every good and perfect gift is from above, coming down from the Father of the heavenly lights.", ref: "James 1:17" },
  ],
};
